<lcp-header [isInverted]="true"></lcp-header>

<div class="main-content-container padding-bottom-0">
  <ng-container *ngIf="fields">
    <section class="lcp-section is-banner is-background-teal">
    <!-- <section [ngClass]="[
      'lcp-section', 
      !!fields['bannerColor'] && 'is-banner',
      fields['bannerColor'] && 'is-background-' + fields['bannerColor']
    ]"> -->
      <div class="lcp-section-content position-relative">
        <div class="display-flex">
          <h1 *ngIf="fields['title']" class="section-title margin-top-20 margin-bottom-80 flex-50-not-sm color-white">
            {{ fields['title'] }}
          </h1>
        </div>

        <div *ngIf="fields['banner']" class="service-banner-image-container">
          <img [src]="lcpHelper.urlFromMedia(fields['banner'][0])">
        </div>
      </div>
    </section>

    <section *ngFor="let section of fields['sections']; let i = index;"
      [ngClass]="['lcp-section', 'lcp-' + section.fields['slug']]"
      [class.lcp-service-categories]="i == 1"
      [class.is-inverted]="section.fields['inverted']">

      <div class="lcp-section-content">
        <h2 *ngIf="section.fields['title']" class="section-title">
          {{ section.fields['title'] }}
        </h2>
      
        <div class="section-main-content">
          <ng-container *ngIf="i == 0">
            <ng-content *ngTemplateOutlet="serviceSummaryTemplate; context:{ section: section }"></ng-content>
          </ng-container>
  
          <ng-container *ngIf="i == 1">
            <ng-content *ngTemplateOutlet="serviceCategoriesTemplate; context:{ section: section }"></ng-content>
          </ng-container>
        </div>
      </div>
    </section>
  </ng-container>
</div> 

<ng-template #serviceSummaryTemplate let-section="section">
  <div class="service-summary-container">
    <div class="service-description" *ngFor="let block of section.fields['items']">
      <lcp-rich-text
        class="lcp-subheading"
        [document]="block.fields['body']">
      </lcp-rich-text>
    </div>
  </div>
</ng-template>

<ng-template #serviceCategoriesTemplate let-section="section">
  <div class="service-categories-container">
    <div class="category-divider display-none-sm"></div>
    <ng-container *ngFor="let block of section.fields['items']; index as i">
      <div class="service-category-container">
        <div class="category-wrapper-mobile typable-wrapper-mobile display-block-only-sm">
          <ng-content *ngTemplateOutlet="serviceCategoryMobile; context:{ block: block, index: i }"></ng-content>
        </div>

        <div class="category-wrapper-desktop typable-wrapper-desktop display-none-sm">
          <ng-content *ngTemplateOutlet="serviceCategoryDesktop; context:{ block: block, index: i }"></ng-content>
        </div>

        <div class="service-category-image-container">
          <div class="service-category-image" *ngIf="block.fields['media']">
            <img [src]="lcpHelper.urlFromMedia(block.fields['media'][0])">
          </div>
        </div>
        <!-- <div class="category-divider"></div> -->
      </div>
      <div class="category-divider"></div>
    </ng-container>
  </div>
</ng-template>



<ng-template #serviceCategoryDesktop let-block="block" let-index="index">
  <div [ngClass]="['service-category', 'service-category-' + index, 'typable-container']" 
    [id]="'service-category-desktop-' + index"
    (mouseover)="handleHoverCategory({ event: $event, text: documentToPlainTextString(block.fields['body']), index: index })"
    (mouseleave)="handleBlurCategory({ event: $event, index: index })"
    (click)="handleSelectCategory(block)"
    (keydown.enter)="handleSelectCategory(block)"
    tabindex="0">

    <!-- (focus)="handleHoverCategory({ block: block, index: index })" -->

    <div class="service-category-flex">
      <div class="service-category-flex-left">
        <h4 class="service-category-title">{{ block.fields['title'] }}</h4>
        <div class="typable-text-container">
          <div class="typable-cursor-empty"></div>
          <div class="typable-text-outer">
            <span class="typable-text"></span>
            <span class="typable-cursor-container">
              <div class="typable-cursor"></div>
            </span>
          </div>
          <!-- <div class="typable-text-placeholder">{{ lcpHelper.richTextToString(block.fields['body']) }}</div> -->
          <div class="typable-text-placeholder word-break-all">{{ descriptionPlaceholder }}</div>
        </div>
      </div>
      
      <div class="service-category-flex-right">
        <lcp-rich-text class="service-category-list"
          *ngIf="block.fields['items']"
          [document]="block.fields['items'][0].fields['body']">
          <!-- <img [src]="lcpHelper.urlFromMedia(block.fields['media'][0])"> -->
        </lcp-rich-text>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #serviceCategoryMobile let-block="block" let-service="service">
  <div class="service-category typable-container">
    <div class="service-category-flex">
      <div class="service-category-flex-left">
        <h4 class="service-category-title">{{ block.fields['title'] }}</h4>
        <div class="typable-text-container">
          <div class="typable-cursor-empty"></div>
          <div class="typable-text-outer">
            <span class="typable-text"></span>
            <span class="typable-cursor-container">
              <div class="typable-cursor"></div>
            </span>
          </div>
          <div class="typable-text-placeholder">{{ lcpHelper.richTextToString(block.fields['body']) }}</div>
        </div>
      </div>
            
      <div class="service-category-flex-right">
        <lcp-rich-text class="service-category-list"
          *ngIf="block.fields['items']"
          [document]="block.fields['items'][0].fields['body']">
          <!-- <img [src]="lcpHelper.urlFromMedia(block.fields['media'][0])"> -->
        </lcp-rich-text>
      </div>
    </div>
  </div>
</ng-template>